import { useLateAddToCartOrderEligibility } from './useLateAddToCartOrderEligibility';
import { useLateAddToCartUserEligibility } from './useLateAddToCartUserEligibility';

export const useDisplayOrderDetailEntrypoint = (orderId: string) => {
  const { isEligible: isOrderEligible, ...orderEligibility } =
    useLateAddToCartOrderEligibility(orderId);
  const { isEligible: isUserEligible, ...userEligibility } =
    useLateAddToCartUserEligibility();

  const displayEntrypoint = isOrderEligible && isUserEligible;

  const loading = orderEligibility.loading || userEligibility.loading;

  return { displayEntrypoint, loading };
};
